export const studyMissionsConstants = {
    // Retrait d'une proposition du brouillon Sam, à l'initiative du tuteur.
    // Le retrait doit vivre dans le brouillon lui-même : mémorisé à côté, il
    // disparaissait au rechargement et la proposition réapparaissait.
    REMOVE_DRAFT_ACTIVITY: "REMOVE_DRAFT_ACTIVITY",
}
